import React, { Component } from "react";
import { Consumer } from "../libs/AuthContext";
import  Auth  from "@aws-amplify/auth";
import { Header, Button, Form, Message, Icon, List, Grid, Divider, Segment, Label , Menu} from "semantic-ui-react";
import "./Signup.css";
import { translate } from 'react-i18next';
import i18n from "i18next";
import {languages, languagesFR} from "../libs/utility";
import {navigate} from "gatsby";

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      type: "password",
      action: "Show",
      actionFR: "Afficher",
      confirmation: "",
      newUser: null,
      error: false,
      errorMessage: "",
      newsletter: true
    };
  }

  async componentDidMount() {
    const passwordField = document.getElementById("password");
    if (passwordField){
      passwordField.addEventListener( 'keydown', function( event ) {
        let caps = event.getModifierState && event.getModifierState( 'CapsLock' );
        let capsLock = document.getElementById("capsLock");
        if (capsLock) {
          capsLock.style.display = caps ? "block" : "none";
        }
      });
      passwordField.addEventListener( 'keyup', function( event ) {
        let caps = event.getModifierState && event.getModifierState( 'CapsLock' );
        let capsLock = document.getElementById("capsLock");
        if (capsLock) {
          capsLock.style.display = caps ? "block" : "none";
        }
      });
    }
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 //&&
      //this.state.password === this.state.confirmPassword
    );
  }

  validatePassword() {
    return (
      this.state.password.length
    )
  }

  validateConfirmationForm() {
    return this.state.confirmation.length > 0;
  }

  handleChange = (event, data) => {
    this.setState({
      [data.id]: data.value
    });
  }

  handleShowPassword = event => {
    event.preventDefault();

    this.setState({
      type: this.state.type === "input" ? "password" : "input",
      action: this.state.action === "Show" ? "Hide" : "Show"
    })
  }

  handleShowPasswordFR = event => {
    event.preventDefault();

    this.setState({
      type: this.state.type === "input" ? "password" : "input",
      actionFR: this.state.actionFR === "Afficher" ? "Masquer" : "Afficher"
    })
  }

  handleSubmit = async event => {
    event.preventDefault();
    let email = this.state.email.toLowerCase();
    this.setState({ isLoading: true });

    try {
      const newUser = await Auth.signUp({
        username: email,
        password: this.state.password
      });
      this.setState({
        newUser,
        email: email
      });
    } catch (e) {
      if (e.message === 'Password did not conform with policy: Password must have symbol characters') {
        this.setState({ error: true, errorMessage: 'Password did not conform with policy: Special characters only include: ~!@#$%^&*_-= (){}[]<>,.?" \' ` \\ / |' });
      }
      else {
      console.log(e);
      this.setState({ error: true, errorMessage: e.message });
      }
    }

    this.setState({ isLoading: false });
  }

  handleConfirmationSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await Auth.confirmSignUp(this.state.newUser.user.username, this.state.confirmation);
      await Auth.signIn(this.state.email, this.state.password);

      this.props.context.userHasAuthenticated(true);
      navigate("/");

    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  checkSpecialChar (password) {
    var format = /[^A-Z\s\d]/ig;
    if (format.test(password)) {
      return true;
    } else {
      return false;
    }
  }

  renderConfirmationForm() {
    const { t } = this.props
    return (
      <Form onSubmit={this.handleConfirmationSubmit} autoComplete="nope" style={{width: "50%"}}>
        <Form.Input
          id="confirmation"
          placeholder={t("Confirmation Code")}
          type="number"
          defaultValue={this.state.confirmationCode}
          onChange={this.handleChange}
          size="huge"
        />
        <Message size="tiny" >
          <Icon name="inbox" />
          {t('Please check your email for the code If you do not recieve an email from infoscenarexca in the next 10 minutes please check your spam folder')}
        </Message>
          <Button
            fluid
            disabled={!this.validateConfirmationForm()}
            type="submit"
            loading={this.state.isLoading}
          >
            {t('Verify')}
          </Button>
      </Form>
    );
  }

  renderForm() {
    const { t } = this.props
    return (
      <div>
        <p style={{textAlign: "center", paddingBottom: "2em", color: "#39474F"}}>{t('Already have an account?')} <a href="/login"> {t('Sign in here')} </a></p>
        <Form error={this.state.error} onSubmit={this.handleSubmit} className="loginForm">
          <Form.Input
            focus
            id="email"
            label={t("Email Address")}
            type="email"
            defaultValue={this.state.email}
            onChange={this.handleChange}
          />
          { i18n.language !== "fr" &&
            <Form.Input
              action={{ content: this.state.action, onClick: this.handleShowPassword, size: "mini" }}
              id="password"
              label={t("Password")}
              value={this.state.password}
              onChange={this.handleChange}
              type={this.state.type}
            />
          }
          { i18n.language === "fr" &&
            <Form.Input
              action={{ content: this.state.actionFR, onClick: this.handleShowPasswordFR, size: "mini" }}
              id="password"
              label={t("Password")}
              value={this.state.password}
              onChange={this.handleChange}
              type={this.state.type}
            />
          }
          <Label basic color='red' pointing id="capsLock" style={{display: "none"}}>
            {t("Caps Lock is on")}
          </Label>
          <Segment.Group horizontal>
          <Segment className="passwordReq">
            <List size="mini">
              <List.Item
                icon={{
                  name: "check",
                  color: this.state.password.match(/[A-Z]/) ? "green" : "grey"
                }}
                content={t("One uppercase character")}
              />
              <List.Item
                icon={{ name: "check",
                color: this.state.password.match(/[a-z]/) ? "green" : "grey"
              }}
                content={t("One lowercase character")}
              />
              <List.Item
                icon={{
                  name: "check",
                  color: /\d/.test(this.state.password) ? "green" : "grey",
              }}
                content={t("One number")}
              />
            </List>
            </Segment>
            <Segment className="passwordReq">
            <List size="mini">
              <List.Item
                icon={{
                  name: "check",
                  color: this.checkSpecialChar(this.state.password) ? "green" : "grey"
                }}
                content={t("One special character")}
              />
              <List.Item
                icon={{
                  name: "check",
                  color: this.state.password.length > 7 ? "green" : "grey"

                }}
                content={t("8 characters minimum")}
              />
            </List>
            </Segment>
          </Segment.Group>
          <Divider hidden />
          <Message
            error
            header="Ooops!"
            content={this.state.errorMessage}
          />
          <Form.Checkbox
            style={{color: "#39474F"}}
            id="newsletter"
            label={t("Subscribe to newsletter")}
            onChange={this.handleChange}
            checked={this.state.newsletter}
          />
          <p style={{fontSize: "0.75rem", color: "#39474F"}}>
            {t('By clicking this button, you agree to our')} <a href="http://bookchain-site.s3-website-us-east-1.amazonaws.com/terms">{t('Terms of Service')}</a>, {t('and')} <a href="http://bookchain-site.s3-website-us-east-1.amazonaws.com/privacy">{t('Privacy Policy')}</a>
          </p>
          <Button
            fluid
            disabled={!this.validateForm()}
            type="submit"
            loading={this.state.isLoading}
          >
            {t('Sign Up')}
          </Button>
        </Form>
        <Divider hidden />
        <p style={{textAlign: "center", color: "#39474F"}}>{t('Forgot your verification code')}<a href="/signup/forgotcode"> {t('Click here to resend the code')}</a></p>
      </div>
    );
  }

  render() {
    const { t } = this.props
    return (
      <main className="Signup">
      <Segment textAlign='center' vertical className="topMenuSeg">
        <Menu fixed="top" borderless size="small" as="nav" style={{borderBottomColor: "rgba(34, 36, 38, 0.15", backgroundColor: "#39474F"}}>
          <Menu.Item>
            <a href="/"><img style={{width: "170px", height: "auto"}}src={"/logo-horizontal.png"} alt=""/></a>
          </Menu.Item>
          <Menu.Menu position="right" className="headerComp">
              <Menu.Item >
                <a href="https://www.bookchain.ca/" style={{color: "#FFFFFF"}}>{t('Homepage')}</a>
              </Menu.Item>
              <Menu.Item >
                <a href="https://www.bookchain.ca/whatisbookchain" style={{color: "#FFFFFF"}}>{t('What is Bookchain®?')}</a>
              </Menu.Item>
              <Menu.Item>
                <Form.Dropdown
                  fluid
                  selection
                  options={i18n.language === "en" ? languages : languagesFR}
                  value={i18n.language}
                  onChange={(event,data) => i18n.changeLanguage(data.value)}
                  />
              </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Segment>
      <Grid centered className="loginMain">
        <Grid.Column computer={9} mobile={16}>
          <Segment className="segmentLogin">
            <Header as="h2" textAlign={"center"}>{t('Create Your Account')}</Header>
              {this.state.newUser === null
                ? this.renderForm()
                : this.renderConfirmationForm()}
            </Segment>
          </Grid.Column>
        </Grid>
        <div className="trim" style={{zIndex: "100", maxHeight: "300px"}}>
          <img alt="" width={400} height={400} align='bottom' src={"copyrightwhite.png"} style={{marginLeft: -170}}/>
        </div>
      </main>
    );
  }
}

export default translate("translations")(props => (
  <Consumer>
    {value => <Signup {...props} context={value} />}
  </Consumer>
)
)
